import { useStaticQuery, graphql } from "gatsby"

export const useGetPages = () => {
  const { all_pages } = useStaticQuery(
    graphql`
      query UseGetPagesQuery {
        all_pages: allMarkdownRemark(
          filter: { fileAbsolutePath: { regex: "/(/content/pages)/" } }
        ) {
          edges {
            node {
              frontmatter {
                title
                page_id
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `
  )
  return all_pages
}
